import clsx from 'clsx'
import {KTIcon, toAbsoluteUrl} from '../../../helpers'
import {HeaderUserMenu, Search, ThemeModeSwitcher} from '../../../partials'
import {useLayout} from '../../core'
import {useAuth} from '../../../../app/modules/auth'
import {useState, useEffect, useRef} from 'react'
import {Link} from 'react-router-dom'
import {listSimpleSearch} from '../../../../app/modules/library/components/_requests'

interface SearchResult {
  recordId: string
  libraryName: string
  [key: string]: any
  lastModifiedDate: string
}

const itemClass = 'ms-1 ms-lg-3'
const btnClass =
  'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px w-md-40px h-md-40px'
const userAvatarClass = 'symbol-35px symbol-md-40px'
const btnIconClass = 'fs-1'

const Navbar = () => {
  const {config} = useLayout()
  const {currentUser, logout} = useAuth()
  const [searchQuery, setSearchQuery] = useState('')
  const [searchResults, setSearchResults] = useState<SearchResult[]>([])
  const [loading, setLoading] = useState(false)
  const [showResults, setShowResults] = useState(false)
  const searchRef = useRef<HTMLDivElement>(null)

  const fetchSearchResults = async (query: string) => {
    if (!query || query.length < 2) {
      setSearchResults([])
      setShowResults(false)
      return
    }

    setLoading(true)
    try {
      const response = await listSimpleSearch({
        rawCondition: query,
        pageNumber: 1,
      })
      if (response?.data) {
        setSearchResults(response.data)
        setShowResults(true)
      } else {
        setSearchResults([])
        setShowResults(false)
      }
    } catch (err) {
      console.error('Error fetching search results:', err)
      setSearchResults([])
      setShowResults(false)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (searchQuery.length === 0) {
      setSearchResults([])
      setShowResults(false)
      return
    }

    const timeoutId = setTimeout(() => {
      if (searchQuery.length >= 2) {
        fetchSearchResults(searchQuery)
      }
    }, 500)

    return () => clearTimeout(timeoutId)
  }, [searchQuery])

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (searchRef.current && !searchRef.current.contains(event.target as Node)) {
        setShowResults(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && searchQuery.trim()) {
      e.preventDefault()
      fetchSearchResults(searchQuery.trim())
    }
  }

  return (
    <div className='app-navbar flex-shrink-0'>
      {/* Search Bar with Red Accent */}
      <div className={clsx('app-navbar-item align-items-center', itemClass)} style={{position: 'relative'}} ref={searchRef}>
       <Search />
        {/* <div className='position-relative' style={{width: '250px'}}>
          <div style={{left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#a1a5b7'}} className='position-absolute'>
            <KTIcon
              iconName='magnifier'
              className='fs-3'
            />
          </div>
          <input
            type='text'
            className='form-control form-control-sm'
            placeholder='Search...'
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyDown={handleKeyDown}
            onFocus={() => searchQuery.length >= 2 && setShowResults(true)}
            style={{
              paddingLeft: '40px',
              border: 'none',
              borderBottom: '2px solid #dc3545',
              borderRadius: '0',
              backgroundColor: 'transparent',
              outline: 'none',
            }}
          />
          
          {showResults && (
            <div
              className='menu menu-sub menu-sub-dropdown p-5 w-325px'
              style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                marginTop: '8px',
                backgroundColor: 'white',
                boxShadow: '0 0 50px 0 rgba(82, 63, 105, 0.15)',
                borderRadius: '0.475rem',
                zIndex: 9999,
                maxHeight: '400px',
                overflowY: 'auto',
              }}
            >
              {loading ? (
                <div className='text-center py-5'>
                  <span className='spinner-border text-primary' />
                </div>
              ) : searchResults.length > 0 ? (
                <>
                  <div className='mb-3'>
                    <h6 className='text-gray-800 fw-bold mb-3'>Search Results</h6>
                    <Link
                      to='library/search_results'
                      state={{results: searchResults}}
                      className='btn btn-sm btn-danger w-100'
                      onClick={() => setShowResults(false)}
                    >
                      View All Results ({searchResults.length})
                    </Link>
                  </div>
                  <div className='separator my-3'></div>
                  <div>
                    {searchResults.slice(0, 5).map((result, index) => (
                      <div
                        key={result.recordId || index}
                        className='d-flex align-items-center py-2 border-bottom'
                      >
                        <div className='flex-grow-1'>
                          <div className='text-gray-800 text-hover-primary fw-bold fs-7'>
                            {result.libraryName || 'Untitled'}
                          </div>
                          <div className='text-gray-600 fs-8'>
                            {result.recordId}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <div className='text-center py-5'>
                  <KTIcon iconName='search-list' className='fs-3x opacity-50 mb-3' />
                  <div className='text-gray-600 fw-bold'>No results found</div>
                </div>
              )}
            </div>
          )}
        </div> */}
      </div>

      {/* Username Display */}
      <div className={clsx('app-navbar-item align-items-center', itemClass)}>
        <div
          className='d-flex align-items-center cursor-pointer'
          // data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <span className='text-gray-800 fw-bold fs-6' style={{whiteSpace: 'nowrap'}}>
            {currentUser?.username || currentUser?.first_name || 'User'}
          </span>
        </div>
        <HeaderUserMenu />
      </div>

      {/* Logout Button */}
      <div className={clsx('app-navbar-item', itemClass)}>
        <button
          className={clsx('btn btn-icon ', btnClass)}
          onClick={logout}
          title='Logout'
        >
          <KTIcon iconName='exit-right' className={btnIconClass} />
        </button>
      </div>

      {config.app?.header?.default?.menu?.display && (
        <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-35px h-35px'
            id='kt_app_header_menu_toggle'
          >
            <KTIcon iconName='text-align-left' className={btnIconClass} />
          </div>
        </div>
      )}
    </div>
  )
}

export {Navbar}
